import { withTopbarProps } from '@jusbrasil/topbar'
import { withUserSession } from '@jusbrasil-web/shared-user-session'
import { GetServerSideProps } from 'next'
import { useRouter } from 'next/router'

import { internalAuthApi } from '../../../api'
import { AuthLayout, EmailPasswordReset, ForgotPassword } from '../../../components'
import { getAuthServerUrl } from '../../../experiments'
import { usePasswordRecovery } from '../../../hooks/usePasswordRecovery'

export interface PasswordRecoveryPageProps {
  csrfToken?: string | null
  authCsrfToken?: string | null
}

export function PasswordRecoveryPage() {
  const router = useRouter()
  const email = (router.query.email as string) || ''
  const sent = router.query.sent === 'true'

  const { isLoading, error, handleForgotPasswordSubmit } = usePasswordRecovery()

  if (sent) {
    return (
      <AuthLayout>
        <EmailPasswordReset />
      </AuthLayout>
    )
  }

  return (
    <AuthLayout>
      <ForgotPassword
        email={email}
        isLoading={isLoading}
        error={error}
        onSubmit={handleForgotPasswordSubmit}
      />
    </AuthLayout>
  )
}

const getServerSideProps: GetServerSideProps = async (ctx) => {
  const baseUrl = getAuthServerUrl()
  const { csrfToken } = await internalAuthApi.getCsrfToken(ctx, { baseUrl })
  const tokenProp = baseUrl ? { authCsrfToken: csrfToken } : { csrfToken }

  return {
    props: {
      ...withTopbarProps(ctx),
      ...withUserSession(ctx),
      ...tokenProp,
    },
  }
}

export const PasswordRecoveryPageExports = {
  getServerSideProps,
}
